export default "__VITE_ASSET__BAeGOWnj__"